<div class="notification-container" [ngStyle]="borderStyle">
    <p class="notificacion-message">{{ message }}</p>
</div>